import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './color.css';
import './font.css';
import App from './App';
// @sudarsana added here for removal .js extension and src
import './i18n/i18n';
// import flow from './components/flow'
// import store from './store';
// redux : By Abhishek
// import mystore from './states/store';
// redux by kranthi
import { localStore } from './app/store';

// import { cskStore } from './app/store';

const history = createBrowserHistory();

ReactDOM.render(
  <BrowserRouter history={history} forceRefresh>
    <Provider store={localStore}>
      {/* <Provider store={store}> */}
      {/* <Provider store={mystore}> */}
      <App />
      {/* </Provider> */}
      {/* </Provider> */}
    </Provider>
  </BrowserRouter >,
  document.getElementById('root')
);

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
